import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/fonts.css';
import './styles/globals.scss';
import App from './App';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);